import React, { useState, useEffect } from 'react';

function ManageRoles() {
    const [roleName, setRoleName] = useState('');
    const [userId, setUserId] = useState('');
    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    // 1️⃣ Sistemdəki rolları və istifadəçiləri gətir
    useEffect(() => {
        fetchRoles();
        fetchUsers();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await fetch('https://api.herracim.az/api/roles/all');
            const data = await response.json();
            setRoles(data);
        } catch (err) {
            console.error("Rollar yüklənə bilmədi:", err);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch('https://api.herracim.az/api/users');
            const data = await response.json();
            setUsers(data);
        } catch (err) {
            console.error("İstifadəçilər yüklənə bilmədi:", err);
        }
    };
    const handleAddRole = async () => {
        if (!roleName.trim()) {
            setError("Rol adı boş ola bilməz!");
            return;
        }
    
        try {
            const response = await fetch('https://api.herracim.az/api/roles/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include', // ✅ Cookie-ni ötürmək üçün vacibdir
                body: JSON.stringify({ roleName })
            });
    
            if (response.ok) {
                setMessage(`"${roleName}" rolu yaradıldı!`);
                setError(null);
                setRoleName('');
                fetchRoles();
            } else {
                const errorText = await response.text();
                setError(errorText || "Rol əlavə edilə bilmədi.");
            }
        } catch (err) {
            setError("Xəta baş verdi. Zəhmət olmasa sonra cəhd edin.");
        }
    };
    
    
    
    

    // 3️⃣ İstifadəçiyə rol vermək funksiyası
    const handleAssignRole = async () => {
        if (!userId || !selectedRole) {
            setError("İstifadəçi və rol seçilməlidir!");
            return;
        }
    
        try {
            const response = await fetch('https://api.herracim.az/api/user/assign-role', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include', // ✅ Cookie ilə autentikasiya üçün
                body: JSON.stringify({ userId, role: selectedRole })
            });
    
            if (response.ok) {
                setMessage(`İstifadəçiyə "${selectedRole}" rolu verildi!`);
                setError(null);
            } else {
                const errorText = await response.text();
                setError(errorText || "Rol təyin edilə bilmədi.");
            }
        } catch (err) {
            setError("Xəta baş verdi. Zəhmət olmasa sonra cəhd edin.");
        }
    };
    
    return (
        <div style={{ maxWidth: "600px", margin: "50px auto", textAlign: "center", padding: "20px", border: "1px solid #ccc", borderRadius: "8px" }}>
            <h2>Rol İdarəetməsi</h2>

            {message && <p style={{ color: "green" }}>{message}</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}

            {/* 🟢 Yeni Rol Əlavə Etmə Bölməsi */}
            <div style={{ marginBottom: "20px" }}>
                <h3>Yeni Rol Əlavə Et</h3>
                <input
                    type="text"
                    placeholder="Rol adı daxil edin"
                    value={roleName}
                    onChange={(e) => setRoleName(e.target.value)}
                    style={{ padding: "10px", width: "100%", marginBottom: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                />
                <button
                    onClick={handleAddRole}
                    style={{ padding: "10px", width: "100%", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                >
                    Rolu Əlavə Et
                </button>
            </div>

            {/* 🟡 İstifadəçiyə Rol Təyin Etmə Bölməsi */}
            <div>
                <h3>İstifadəçiyə Rol Təyin Et</h3>
                <select 
                    onChange={(e) => setUserId(e.target.value)} 
                    value={userId} 
                    style={{ padding: "10px", width: "100%", marginBottom: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                >
                    <option value="">İstifadəçi seç</option>
                    {users.map((user) => (
                        <option key={user.id} value={user.id}>{user.fullName} ({user.email})</option>
                    ))}
                </select>

                <select 
                    onChange={(e) => setSelectedRole(e.target.value)} 
                    value={selectedRole} 
                    style={{ padding: "10px", width: "100%", marginBottom: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                >
                    <option value="">Rol seç</option>
                    {roles.map((role) => (
                        <option key={role.id} value={role.name}>{role.name}</option>
                    ))}
                </select>

                <button
                    onClick={handleAssignRole}
                    style={{ padding: "10px", width: "100%", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                >
                    Rolu Təyin Et
                </button>
            </div>
        </div>
    );
}

export default ManageRoles;
